module.exports = __webpack_public_path__ + "img/magic-breadcrumb-icon.e958d660.png";